import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d0d8bbea"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedInput = _resolveComponent("FriedInput");
    const _component_FriedSelect = _resolveComponent("FriedSelect");
    const _component_HiddenInput = _resolveComponent("HiddenInput");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_PasswordValidator = _resolveComponent("PasswordValidator");
    const _component_FriedButton = _resolveComponent("FriedButton");
    return (_openBlock(), _createElementBlock("form", {
        class: "verify-user-form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
        _createVNode(_component_FriedInput, {
            modelValue: _ctx.profileInformation.firstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.profileInformation.firstName) = $event)),
            modelModifiers: { trim: true },
            autofocus: !_ctx.profileInformation.firstName,
            "data-external": "signup-verify-user-first-name-input",
            label: _ctx.$t('first-name'),
            autocomplete: "first-name",
            "error-message": _ctx.validation.firstName
        }, null, 8, ["modelValue", "autofocus", "label", "error-message"]),
        _createVNode(_component_FriedInput, {
            modelValue: _ctx.profileInformation.lastName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.profileInformation.lastName) = $event)),
            modelModifiers: { trim: true },
            autofocus: _ctx.profileInformation.firstName && !_ctx.profileInformation.lastName,
            "data-external": "signup-verify-user-last-name-input",
            label: _ctx.$t('last-name'),
            autocomplete: "family-name",
            "error-message": _ctx.validation.lastName
        }, null, 8, ["modelValue", "autofocus", "label", "error-message"]),
        _createVNode(_component_FriedSelect, {
            options: _ctx.languages,
            "data-external": "signup-verify-user-language-dropdown",
            "append-to-body": true,
            "model-value": _ctx.languageObject,
            "option-label": "label",
            label: _ctx.$t('language'),
            "empty-state-text": _ctx.$t('no-items-found'),
            "error-message": _ctx.validation.language,
            "onUpdate:modelValue": _ctx.handleLanguageChange
        }, null, 8, ["options", "model-value", "label", "empty-state-text", "error-message", "onUpdate:modelValue"]),
        _createVNode(_component_FriedInput, {
            "model-value": _ctx.unFormattedPhoneNumber,
            "data-external": "signup-verify-user-phone-number-input",
            type: "tel",
            autocomplete: "off",
            label: _ctx.phoneNumberLabel,
            placeholder: "+123456789",
            "error-message": _ctx.validation.phoneNumber,
            "onUpdate:modelValue": _ctx.handlePhoneNumberInput
        }, null, 8, ["model-value", "label", "error-message", "onUpdate:modelValue"]),
        _createVNode(_component_HiddenInput, { autocomplete: "email" }),
        _createVNode(_component_FriedInput, {
            modelValue: _ctx.profileInformation.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.profileInformation.password) = $event)),
            autofocus: !!_ctx.profileInformation.firstName && !!_ctx.profileInformation.lastName,
            "data-external": "signup-verify-user-password-input",
            type: _ctx.passwordInputType,
            label: _ctx.$t('password'),
            autocomplete: "new-password",
            "error-message": _ctx.validation.password,
            "help-message": _ctx.$t('password-must-include'),
            onFocus: _ctx.handlePasswordFocus,
            onBlur: _ctx.handlePasswordBlur
        }, {
            append: _withCtx(() => [
                _createElementVNode("button", {
                    type: "button",
                    tabindex: "-1",
                    class: "view-password-button",
                    "data-external": "signup-verify-user-view-password-button",
                    title: _ctx.$t('show-and-hide-password'),
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.toggleViewPassword && _ctx.toggleViewPassword(...args)), ["prevent"]))
                }, [
                    (!_ctx.viewPassword)
                        ? (_openBlock(), _createBlock(_component_FriedIcon, {
                            key: "1",
                            "aria-hidden": "",
                            icon: "view"
                        }))
                        : (_openBlock(), _createBlock(_component_FriedIcon, {
                            key: "2",
                            "aria-hidden": "",
                            icon: "view-hide"
                        }))
                ], 8, _hoisted_1)
            ]),
            _: 1
        }, 8, ["modelValue", "autofocus", "type", "label", "error-message", "help-message", "onFocus", "onBlur"]),
        _createVNode(_component_PasswordValidator, {
            input: _ctx.profileInformation.password,
            class: "password-validator",
            "show-errors": _ctx.showValidatorError,
            onIsValidPassword: _ctx.handleIsValidPassword
        }, null, 8, ["input", "show-errors", "onIsValidPassword"]),
        _createVNode(_component_FriedButton, {
            type: "submit",
            "data-external": "signup-verify-user-submit-button",
            loading: _ctx.loading,
            class: "submit-button"
        }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('continue')), 1)
            ]),
            _: 1
        }, 8, ["loading"])
    ], 32));
}
